import { Box, Button, Grid2 } from "@mui/material";
import React, { useState, useEffect } from "react";
import SideBar from "../SideBar/SideBar";
import { useTheme, useMediaQuery } from "@mui/material";
import '../Assistant/Assistant.css';
import AutoAwesomeIcon from '@mui/icons-material/AutoAwesome';
import Modal from '@mui/material/Modal';
import Stack from "@mui/material/Stack";
import Typography from '@mui/material/Typography';
import TextField from "@mui/material/TextField";
import DeleteIcon from '@mui/icons-material/Delete';
import { ToastContainer, toast } from 'react-toastify';
import { Link, useNavigate } from "react-router-dom";
const drawerWidth = 300;

const APIDeveloper = () => {
    const notify = () => toast.success('Setup Completed');
    const remove = () => toast.success('Deleted successfully');
  
    const theme = useTheme();
    const isLgUp = useMediaQuery(theme.breakpoints.up("sm"));
  
    const [pop, setPop] = useState(false);
    const handlePopOpen = () => setPop(true);
    const handlePopClose = () => setPop(false);
  
    const navigate = useNavigate();
  return (
    <div className="dashboard">
    {/* <Box sx={{ display: isLgUp ? "flex" : "block", marginTop: "20px" }}>
      <SideBar />

      <Box
        component="main"
        sx={{
          flexGrow: 1,
          p: isLgUp ? 5 : 1,
          width: { sm: `calc(100% - ${drawerWidth}px)` },
          marginTop: isLgUp ? "50px" : "80px",
        }}
      > */}
        <Grid2 container spacing={2}>
          <Grid2
            item
            size={{ xs: 12, sm: 12, md: 12, lg: 12, xl: 12 }}
            className="mb-20 mt-50"
          >
            <div className="create-assitant">
              <h1>API Developer coming soon</h1>
            </div>
       
          </Grid2>
        </Grid2>
      {/* </Box>
    </Box> */}
  </div>
  )
}

export default APIDeveloper